"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _style = require("../utils/style");
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  right: 0;\n  bottom: 0;\n"]);
  _templateObject7 = function _templateObject7() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  left: 0;\n  bottom: 0;\n"]);
  _templateObject6 = function _templateObject6() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  right: 0;\n  top: 0;\n"]);
  _templateObject5 = function _templateObject5() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  left: 0;\n  top: 0;\n"]);
  _templateObject4 = function _templateObject4() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  position: relative;\n  overflow: hidden;\n  animation: ", " ", "s linear infinite;\n  > div {\n    width: ", ";\n    height: ", ";\n    border-radius: 50%;\n    position: absolute;\n    background-color: ", ";\n    animation: ", " ", "s linear infinite alternate;\n  }\n  > div:nth-of-type(1) {\n    animation-delay: 0s;\n  }\n  > div:nth-of-type(2) {\n    animation-delay: ", "s;\n  }\n  > div:nth-of-type(3) {\n    animation-delay: ", "s;\n  }\n  > div:nth-of-type(4) {\n    animation-delay: ", "s;\n  }\n"]);
  _templateObject3 = function _templateObject3() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0.3;\n  }\n"]);
  _templateObject2 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    transform: rotate(0);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var rotate = (0, _styledComponents.keyframes)(_templateObject());
var opacityChange = (0, _styledComponents.keyframes)(_templateObject2());
var LoadContainer = _styledComponents.default.div(_templateObject3(), function (props) {
  return _style.sizeContainer[props.size] || _style.sizeContainer['default'];
}, function (props) {
  return _style.sizeContainer[props.size] || _style.sizeContainer['default'];
}, rotate, function (props) {
  return props.speed || 2.4;
}, function (props) {
  return _style.sizeItem[props.size] || _style.sizeItem[props.size];
}, function (props) {
  return _style.sizeItem[props.size] || _style.sizeItem[props.size];
}, function (props) {
  return props.color || '#00adb5';
}, opacityChange, function (props) {
  return props.speed || 2.4;
}, function (props) {
  return props.speed / 3 || 0.8;
}, function (props) {
  return props.speed / 3 * 2 || 1.6;
}, function (props) {
  return props.speed / 3 * 3 || 2.4;
});
var CircleOne = _styledComponents.default.div(_templateObject4());
var CircleTwo = _styledComponents.default.div(_templateObject5());
var CircleThree = _styledComponents.default.div(_templateObject6());
var CircleFour = _styledComponents.default.div(_templateObject7());
var RotateCircleLoading = function RotateCircleLoading(_ref) {
  var _ref$style = _ref.style,
    style = _ref$style === void 0 ? _style.commonStyle : _ref$style,
    color = _ref.color,
    speed = _ref.speed,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'default' : _ref$size;
  return _react.default.createElement(LoadContainer, {
    style: style,
    speed: speed,
    color: color,
    size: size
  }, _react.default.createElement(CircleOne, {
    color: color,
    speed: speed,
    size: size
  }), _react.default.createElement(CircleTwo, {
    color: color,
    speed: speed,
    size: size
  }), _react.default.createElement(CircleThree, {
    color: color,
    speed: speed,
    size: size
  }), _react.default.createElement(CircleFour, {
    color: color,
    speed: speed,
    size: size
  }));
};
var _default = RotateCircleLoading;
exports.default = _default;